export const formatDate = (input: string | Date): string => {
  if (!input) return 'Chybné datum'
  const date = typeof input === 'string' ? new Date(input) : input
  const dd = String(date.getDate()).padStart(2, '0')
  const mm = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-indexed in JavaScript
  const yyyy = date.getFullYear()
  return dd + '.' + mm + '.' + yyyy.toString().slice(2)
}
export const isSameDay = (date1: Date, date2: Date) => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  )
}

export const toHourMinString = (input: Date | string): string => {
  if (!input) return 'Chybné datum'
  const date = typeof input === 'string' ? new Date(input) : input
  return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
}

export const toHourMinSecUTCString = (input: Date | string): string => {
  if (!input) return 'Chybné datum'
  const date = typeof input === 'string' ? new Date(input) : input
  return `${date.getUTCHours()}:${date.getUTCMinutes()}:${date.getUTCSeconds()}`
}

export const toDateHourString = (input: Date | string): string => {
  if (!input) return 'Chybné datum'
  return `${formatDate(input)} ${toHourMinString(input)}`
}

export const getLocalizedDateString = (date: Date): string => {
  if (!date) return 'Chybné datum'
  const tzOffset = (date.getTimezoneOffset() + 60) * 60000
  const localDate = new Date(date.getTime() - tzOffset)

  return localDate.toISOString().split('T')[0]
}

export const getLocalizedDateTimeString = (
  date: Date,
  hour: string
): string => {
  const localHour = Number.parseInt(hour)

  // Adjust it to match the timezone of dateFilter
  const adjustedHour = localHour - date.getTimezoneOffset() / 60

  // // Making sure hours stay within the 0-24 range
  // if (adjustedHour < 0) adjustedHour += 24
  // if (adjustedHour > 23) adjustedHour -= 24

  date.setHours(adjustedHour)
  date.setMinutes(0)
  date.setSeconds(0)
  date.setMilliseconds(0)

  return date.toISOString()
}
